import React from 'react';
import PropTypes from 'prop-types';

import { Button, HeaderTitle } from '@atlas/ui';

import SelfExclusionChip from 'components/ClientProfile/ResponsibleGaming/SelfExclusion/SelfExclusionChip';

const SelfExclusionChips = ({
  isLoading,
  onOpenSubmitPopup,
  selectedPeriod,
  selfExclusionsOptions,
  setSelectedPeriod,
}) => (
  <>
    <div className="title-wrapper">
      <HeaderTitle className="sub-text block-medium" title="self_exclusion_select_period" />
    </div>
    <div className="chips-list">
      {selfExclusionsOptions.map(({ text, value }) => (
        <SelfExclusionChip
          key={value}
          period={value}
          selectedPeriod={selectedPeriod}
          setSelectedPeriod={setSelectedPeriod}
          text={text}
        />
      ))}
    </div>
    <div className="sticky-bottom-buttons-container">
      <Button
        disabled={typeof selectedPeriod !== 'number'}
        label="submit_self_exclusion"
        loading={isLoading}
        onClick={onOpenSubmitPopup}
        size="big"
        type="primary"
      />
    </div>
  </>
);

SelfExclusionChips.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onOpenSubmitPopup: PropTypes.func.isRequired,
  selectedPeriod: PropTypes.string,
  setSelectedPeriod: PropTypes.func.isRequired,
};

export default SelfExclusionChips;
